import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changePhone } from '../../../../../../state/advanced/phone';

import { Phone as PhoneComponent } from './phone';

export const Phone = connect(
  (state: IAppState) => ({
    phone: state.filters.jsonQuery.contact && state.filters.jsonQuery.contact.value,
  }),
  (dispatch: Dispatch) => ({
    onPhoneChange: (value: string | undefined) => {
      dispatch(changePhone(value));
    },
  }),
)(PhoneComponent);
